import React, { createContext, useCallback, useContext } from 'react';
import { useAuth } from '@/context/AuthContext';
import { useFetch } from '../../hooks/useFecth';
import { useClubHealth } from './hooks/useClubHealth';

/** Espelha CLUB_FINANCE_ROLES do server-eurobem: Vendas, Revenda e valores de vendas. */
const CLUB_FINANCE_ROLES = ['owner', 'admin', 'support'];

const ClubContext = createContext({});

export const ClubProvider = props => {
    const { user } = useAuth();
    const { data, mutate } = useFetch(`club`);
    const {
        health,
        mutate: mutateHealth,
        missingCount: personalizationPending,
        resellerPending,
        plansPending,
    } = useClubHealth(Boolean(data?.id));

    const hasCustomApp = data?.functions?.includes('custom_app');
    const hasMultiApp = data?.functions?.includes('multi_app');

    // Plano usa "cupons"; legado pode ter "coupons"
    const hasCoupons =
        data?.functions?.includes('cupons') || data?.functions?.includes('coupons');
    const hasVouchers = data?.functions?.includes('vouchers');
    const hasCashback = data?.functions?.includes('cashback');

    const hasBenefits = data?.functions?.includes('benefit');
    const hasResale = data?.functions?.includes('resale');
    const isReseller = data?.functions?.includes('reseller');
    const canViewFinance = CLUB_FINANCE_ROLES.includes(user?.role);

    const clubCapabilities = {
        canViewFinance,
        hasCustomApp,
        hasMultiApp,
        hasCoupons,
        hasVouchers,
        hasCashback,
        hasBenefits,
        hasResale,
        isReseller,
    };

    const reloadHealth = useCallback(() => mutateHealth(), [mutateHealth]);

    const reload = useCallback(async () => {
        await Promise.all([mutate(), mutateHealth()]);
    }, [mutate, mutateHealth]);

    return (
        <ClubContext.Provider
            value={{
                club: data || null,
                reload,
                reloadHealth,
                health,
                personalizationPending,
                resellerPending,
                canViewFinance,
                plansPending,
                hasCustomApp,
                hasMultiApp,
                hasCoupons,
                hasVouchers,
                hasCashback,
                hasBenefits,
                hasResale,
                isReseller,
                clubCapabilities,
            }}
        >
            <>
                {props.children}
            </>
        </ClubContext.Provider>
    );
};

export const useClub = () => {
    const context = useContext(ClubContext);
    if (!context) throw 'useApp context inside corret provider';

    return context;
};
